/**
 * 試験完了ページ
 *************************************************/
import { Auth } from 'aws-amplify';
import Footer from 'components/common/Footer';
import { endLoading, startLoading } from 'modules/commonModule';
import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Container, Header } from 'semantic-ui-react';

type LocationState = {
  categoryNo: number;
};
const CompletePage: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation<LocationState>();
  const { categoryNo } = location.state;

  useEffect(() => {
    (async () => {
      try {
        dispatch(startLoading());

        // 認証チェック
        const user = await Auth.currentAuthenticatedUser();

        // ユーザーステータスと表示中の問題番号が一致しなければ
        // 解答済の問題と判定してログイン画面へリダイレクト
        if (user.attributes['custom:status'] !== String(categoryNo) && user.attributes['custom:role'] !== 'tester') {
          history.push('/');
        }

        // サインアウト
        Auth.signOut();
      } catch (e) {
        console.log(e);
        // 認証できなかった場合はログイン画面へリダイレクト
        if (e === 'not authenticated') {
          history.push('/');
        }
      } finally {
        dispatch(endLoading());
      }
    })();
  }, [categoryNo, dispatch, history]);

  return (
    <>
      <Container text textAlign="center" style={{ paddingTop: '80px', marginBottom: '70px' }}>
        <Header as="h1" dividing textAlign="center" style={{ paddingBottom: '20px' }}>
          適性検査試験終了
        </Header>
        <p>
          解答結果を送信いたします。
          <br />
          以上で適性検査試験は終了です。
          <br />
          お疲れ様でした。
          <br />
          <br />
          このままブラウザを閉じて終了してください。
        </p>
      </Container>
      <Footer />
    </>
  );
};
export default CompletePage;
